import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { AuthenticationService } from 'app/auth/service/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private toastService: NbToastrService,
    private authenticationService: AuthenticationService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        let messageText = '';
        console.log('Error en el interceptor:', err);

        switch (err.status) {
          case 0: // Backend bajo
            this.router.navigate(['/offline']);
            break;
          case 400: // Bad Request
            this.toastService.danger(err.error.message);
            break;
          case 401: // Unauthorized
            messageText =
              'Su sessi\xF3n ha caducado o no tiene permisos para acceder a la secci\xF3n solicitada.';
            this.toastService.show('El usuario o la contraseña son incorrectos', 'Sesion Caducada', { status: 'danger' });
            this.authenticationService.logout();
            break;
          case 403: // Forbiden
            messageText =
              'No tiene permisos para acceder a la secci\xF3n solicitada.';
            this.toastService.danger(messageText);
            break;
          case 404: // Not Found
            this.toastService.warning(err.error.message);
            break;
          case 409: // Conflict - Utilizado para los errores por lockeo.
            messageText =
              'El registro fue modificado y no es posible guardar sus cambios.  <br/><br/>' +
              'Deber\xe1 refrescar la pantalla y volver a ingresar la informaci\xF3n.';
            break;
          case 498: // Sin asignar
            messageText += err.message;
            break;
          case 500:
            this.toastService.danger('Ha ocurrido un error por favor comuníquese con su Administrador');
            break;
          case 503: // Service Unavailable
            this.router.navigate(['/offline']);
            break;
          default:
            if (err.error !== null) {
              messageText += err.error.message
                ? err.error.message
                : err.statusText;
            } else {
              messageText += err.status + err.statusText;
            }
            break;
        }

        if (messageText !== null) {
          console.log('Ha ocurrido un error. '.concat(messageText));
          // this.toastService.error('Ha ocurrido un error. '.concat(messageText));
        }

        return throwError(err);
      })
    );
  }
}
